import { render, staticRenderFns } from "./PrivacyFooter.vue?vue&type=template&id=5efec5f7&scoped=true&"
import script from "./PrivacyFooter.vue?vue&type=script&lang=js&"
export * from "./PrivacyFooter.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyFooter.vue?vue&type=style&index=0&id=5efec5f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efec5f7",
  null
  
)

export default component.exports